import { Getters } from 'vuex-smart-module';
import BrandsState from './state';

export default class BrandsGetters extends Getters<BrandsState> {}
